// Tiny CSV helper. Uses semicolon separator (Chilean Excel default) and prepends
// the UTF-8 BOM so accents/ñ display correctly when opened in Excel ES.
const SEP = ";";

const escapeCell = (v) => {
  if (v === null || v === undefined) return "";
  let s = String(v);
  // Strip newlines (CSV row breaks) and normalize
  s = s.replace(/\r?\n/g, " ").trim();
  if (s.includes(SEP) || s.includes('"')) {
    s = `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

/**
 * @param {string} filename - without extension
 * @param {Array<{key:string,label:string,format?:(row:any)=>any}>} columns
 * @param {Array<any>} rows
 */
export function downloadCsv(filename, columns, rows) {
  const header = columns.map(c => escapeCell(c.label)).join(SEP);
  const body = rows.map(r => columns.map(c => escapeCell(c.format ? c.format(r) : r[c.key])).join(SEP)).join("\r\n");
  const csv = "\uFEFF" + header + "\r\n" + body;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const ts = new Date().toISOString().slice(0, 10);
  a.href = url;
  a.download = `${filename}_${ts}.csv`;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { URL.revokeObjectURL(url); a.remove(); }, 200);
}
